var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHiking0D626B06(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 406,
    height: 306,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 0,
    width: 338,
    height: 284
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.909 20.062c11.928-8.357 24.848-15.499 38.822-18.487 20.459-4.34 42.077.62 60.453 11.246 22.095 12.746 39.547 32.858 59.417 49.318 23.093 19.107 49.708 33.366 70.582 55.226 20.874 21.86 35.511 54.811 25.976 84.37-8.431 26.163-32.888 42.077-56.651 52.852a323.774 323.774 0 01-171.537 26.726C80.719 275.188 25.957 239.361 26.528 177.16c.576-62.647 29.764-123.05 78.381-157.098z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M104.909 20.062c11.928-8.357 24.848-15.499 38.822-18.487 20.459-4.34 42.077.62 60.453 11.246 22.095 12.746 39.547 32.858 59.417 49.318 23.093 19.107 49.708 33.366 70.582 55.226 20.874 21.86 35.511 54.811 25.976 84.37-8.431 26.163-32.888 42.077-56.651 52.852a323.774 323.774 0 01-171.537 26.726C80.719 275.188 25.957 239.361 26.528 177.16c.576-62.647 29.764-123.05 78.381-157.098z",
    fill: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.06 128.717a170.263 170.263 0 0126.757 18.524c6.61 5.58 12.858 11.699 20.348 16.026 7.489 4.327 16.627 6.695 24.86 4.042 13.986-4.513 22.461-22.232 37.16-22.164 4.012 0 8.314 1.414 11.866-.452 2.177-1.147 3.59-3.304 4.911-5.375l14.879-23.311 13.682 24.613c.62 1.103 1.29 2.263 2.412 2.839 1.556.8 3.428.211 5.183.149 8.028-.279 13.248 10.428 21.277 10.093 2.132-.087 4.246-.986 6.342-.577 3.217.62 5.071 4.011 7.892 5.673 4.34 2.573 10.025.552 14.141-2.393 4.117-2.945 7.744-6.82 12.561-8.401 4.817-1.58 11.401.583 12.039 5.58 5.58-.707 6.442-10.037 11.972-11.06 3.967-.725 6.968 3.323 9.163 6.702a86.995 86.995 0 0036.391 31.469c3.863 1.779 8.481 4.079 8.804 8.32.322 4.24-3.986 7.278-7.75 9.33-57.774 31.513-117.997 63.751-183.694 67.533-32.858 1.859-66.794-3.354-97.997 7.036-14.315 4.768-28.456 12.846-43.397 10.949a4.206 4.206 0 01-1.934-.62c-1.073-.775-1.24-2.288-1.24-3.609-1.15-30.787-2.294-61.578-3.435-92.374-.49-11.159-.973-17.749 6.293-26.453 9.435-11.308 19.876-21.904 30.514-32.089z",
    fill: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M356.937 198.369c-57.768 31.513-117.991 63.751-183.688 67.532-32.858 1.86-66.794-3.354-97.997 7.043-14.309 4.768-28.456 12.833-43.397 10.942a4.157 4.157 0 01-1.928-.62c-1.079-.775-1.24-2.287-1.271-3.608-1.14-30.799-2.284-61.591-3.429-92.374-.074-1.86-.142-3.596-.18-5.232-.192-8.215.46-14.018 6.516-21.271 9.418-11.283 19.858-21.879 30.496-32.064a170.037 170.037 0 0126.758 18.524c6.602 5.58 12.858 11.699 20.347 16.026 7.489 4.327 16.627 6.702 24.86 4.042 13.987-4.513 22.461-22.232 37.161-22.164 4.011 0 8.313 1.414 11.866-.452 2.176-1.147 3.589-3.311 4.91-5.375a49528.33 49528.33 0 0114.879-23.311l3.949 7.105 9.727 17.508c.62 1.103 1.29 2.263 2.412 2.839 1.562.8 3.434.211 5.176.149 8.029-.279 13.255 10.428 21.284 10.093 2.126-.087 4.24-.992 6.336-.583a7.515 7.515 0 013.385 1.817c1.494 1.24 2.827 2.87 4.513 3.868 4.34 2.567 10.025.54 14.141-2.399 4.117-2.939 7.744-6.82 12.561-8.401 4.817-1.58 11.395.583 12.039 5.58 5.58-.713 6.435-10.037 11.972-11.06 3.961-.725 6.968 3.323 9.163 6.702l.266.397a86.907 86.907 0 0036.125 31.078c3.863 1.767 8.488 4.073 8.804 8.314.316 4.24-3.993 7.297-7.756 9.355z",
    fill: "url(#prefix__paint0_linear_15788_47707)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M282.189 174.457c-14.507.589-27.495 9.634-41.928 11.228-12.095 1.332-24.563-2.654-36.379.248-9.572 2.355-17.638 8.995-27.173 11.506-6.2 1.624-12.697 1.432-19.095 1.153a842.8 842.8 0 01-32.473-2.04c10.489 8.178 24.017 11.327 37.197 12.97 13.181 1.643 26.659 2.027 39.461 5.635 10.539 2.97 20.458 8.06 31.109 10.54 10.775 2.517 21.99 2.287 33.044 1.711 20.05-1.048 40.043-3.187 59.895-6.2 11.159-1.711 25.12-4.482 31.419-15.052 5.115-8.587 1.86-21.141-7.117-25.809-7.781-4.055-18.283-3.305-26.658-5.735-7.272-2.114-13.156-5.499-20.806-3.428a83.645 83.645 0 01-20.496 3.273z",
    fill: "url(#prefix__paint1_linear_15788_47707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.789 123.112a5.58 5.58 0 01-.241 1.159c-.825 2.387-2.424 2.189-3.522 4.123-3.496 6.2-1.525 10.254-3.416 16.869-1.444 5.053-6.788 7.905-11.847 9.3-5.059 1.395-10.539 2.089-14.786 5.176-4.247 3.088-6.466 9.87-2.759 13.596-5.741.62-9.33 6.875-14.879 8.525a19.723 19.723 0 01-5.915.533l-36.143-.372c-1.711 0-3.497-.056-5.053-.8-1.736-.856-2.938-2.48-4.123-4.024a70.965 70.965 0 00-18.016-16.373c-1.308-.824-2.697-1.63-4.234-1.736-1.538-.105-2.932.428-4.34.961l-19.181 7.378c-3.584 1.37-7.192 2.765-10.403 4.86-2.89 1.86-5.4 4.284-8.32 6.113a24.959 24.959 0 01-14.606 3.652c-.192-8.215.458-14.018 6.515-21.271 9.461-11.283 19.901-21.879 30.54-32.064a170.041 170.041 0 0126.757 18.524c6.603 5.58 12.858 11.699 20.347 16.026 7.489 4.327 16.628 6.702 24.861 4.042 13.986-4.513 22.461-22.232 37.16-22.164 4.011 0 8.314 1.414 11.866-.452 2.176-1.147 3.59-3.311 4.91-5.375 4.96-7.774 9.92-15.545 14.879-23.311l3.949 7.105z",
    fill: "url(#prefix__paint2_linear_15788_47707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.466 193.075c-6.553-2.034-13.354-3.906-20.18-3.23-9.268.917-17.389 6.391-26.193 9.429-23.844 8.227-49.826-1.897-75.015-1.587-10.279.124-20.459 2.003-30.657 3.168-19.938 2.269-40.074 1.817-60.136 2.443-1.612.049-3.336.142-4.613 1.122-1.86 1.42-2.077 4.098-2.132 6.441-.503 22.561-.856 45.958 8.183 66.64 1.302 2.976 2.951 6.044 5.797 7.619 2.48 1.37 5.461 1.376 8.295 1.345l141.84-1.512c13.02-.143 26.082-.292 38.829-2.833 9.919-1.984 19.466-5.388 28.877-9.046 12.561-4.879 25.251-10.434 34.892-19.838 13.571-13.249 10.353-27.849-2.077-40.403-11.054-11.166-31.153-15.264-45.71-19.758z",
    fill: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M245.466 193.075c-6.553-2.034-13.354-3.906-20.18-3.23-9.268.917-17.389 6.391-26.193 9.429-23.844 8.227-49.826-1.897-75.015-1.587-10.279.124-20.459 2.003-30.657 3.168-19.938 2.269-40.074 1.817-60.136 2.443-1.612.049-3.336.142-4.613 1.122-1.86 1.42-2.077 4.098-2.132 6.441-.503 22.561-.856 45.958 8.183 66.64 1.302 2.976 2.951 6.044 5.797 7.619 2.48 1.37 5.461 1.376 8.295 1.345l141.84-1.512c13.02-.143 26.082-.292 38.829-2.833 9.919-1.984 19.466-5.388 28.877-9.046 12.561-4.879 25.251-10.434 34.892-19.838 13.571-13.249 10.353-27.849-2.077-40.403-11.054-11.166-31.153-15.264-45.71-19.758z",
    fill: "url(#prefix__paint3_linear_15788_47707)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M73.118 241.431c6.442-5.251 13.02-10.589 20.819-13.527 8.784-3.323 18.425-3.348 27.817-3.323l55.716.118c7.966 0 16.324-.062 23.329-3.863a1653.793 1653.793 0 00-175.108-4.848c-.558 10.942-4.34 43.633 8.283 48.729 12.53 5.053 30.998-16.652 39.144-23.286z",
    fill: "url(#prefix__paint4_linear_15788_47707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.671 187.042c-10.471 5.58-19.498 14.166-29.058 20.936-5.021 3.546-56.416 37.198-55.25 40.397l.905 2.48a39.381 39.381 0 003.837 34.643l156.23 3.1c8.45.167 17.235.273 24.916-3.261 3.243-1.501 6.374-3.844 7.496-7.235.669-2.021.564-4.203.452-6.324-1.14-21.078 2.034-48.357-3.719-68.598-2.846-10.031-7.186-7.39-16.944-8.016-9.758-.627-18.797-2.685-27.049-7.025a48.963 48.963 0 01-2.424-1.351c-16.379-9.696-36.081-9.238-53.639-2.375a54.625 54.625 0 00-5.741 2.654",
    fill: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M380.723 278.071c-1.116 3.391-4.246 5.741-7.495 7.235-7.681 3.54-16.466 3.44-24.916 3.267l-156.199-3.1a39.443 39.443 0 01-5.772-27.142 37.43 37.43 0 011.928-7.495c-.298-.831-.62-1.649-.905-2.48-1.166-3.193 50.217-36.844 55.251-40.403 9.56-6.764 18.599-15.369 29.064-20.936a56.647 56.647 0 015.734-2.647 75.843 75.843 0 0111.389-3.466c14.358-3.137 29.343-1.804 42.25 5.84.8.478 1.606.924 2.424 1.358 8.252 4.34 17.272 6.392 27.049 7.018 9.777.626 14.092-2.021 16.944 8.022 5.734 20.211 2.566 47.526 3.719 68.593.099 2.139.211 4.321-.465 6.336z",
    fill: "url(#prefix__paint5_linear_15788_47707)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M288.801 180.923c-.019.441-.065.88-.137 1.315-.768 5.059-1.68 10.409-5.09 14.215-2.765 3.1-6.819 4.7-10.031 7.279-7.923 6.342-10.13 17.551-16.862 25.145-4.582 5.177-11.271 8.717-14.067 15.041-5.475 12.368 4.668 37.228-16.076 40.799-14.067 2.418-30.942-16.193-40.198-26.373a37.43 37.43 0 011.928-7.495c-.298-.831-.62-1.649-.905-2.48-1.166-3.193 50.217-36.844 55.251-40.403 9.559-6.764 18.598-15.369 29.063-20.936a56.33 56.33 0 015.735-2.647 75.821 75.821 0 0111.389-3.46z",
    fill: "url(#prefix__paint6_linear_15788_47707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.831 206.695c1.172 5.958 2.889 11.854 3.144 17.923a1.864 1.864 0 00.551 1.519c.292.154.62.222.949.198h2.201a3.032 3.032 0 001.959-.44c.694-.545.787-1.55.8-2.436.192-11.78-2.821-23.732-.329-35.257.043-.205-6.472.198-7.055.31-2.344.434-2.523 1.357-2.92 3.657-.818 4.836-.229 9.777.7 14.526z",
    fill: "url(#prefix__paint7_linear_15788_47707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.488 185.276a5.086 5.086 0 01-.142 2.132c-.763 3.98-.174 8.06.421 12.096l2.263 15.238c1.24.887 3.1.143 3.931-1.14.83-1.284.917-2.883.979-4.408l.831-21.569a18.692 18.692 0 00-.267-5.102c-.527-2.176-1.816-4.086-3.217-5.834a1.49 1.49 0 00-.726-.589 1.468 1.468 0 00-.855.106c-1.786.619-6.051 2.386-6.783 4.339-.806 2.238 3.026 2.499 3.565 4.731z",
    fill: "url(#prefix__paint8_linear_15788_47707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.88 187.185a1.94 1.94 0 001.959 1.891c4.332.849 8.787.849 13.119 0a1.407 1.407 0 001.049-.47 1.402 1.402 0 00.34-1.099l.905-8.89a70.943 70.943 0 005.127 9.262l14.259-9.987a3.211 3.211 0 001.314-1.401c.298-.874-.204-1.798-.694-2.579a580.553 580.553 0 00-11.159-17.173c-.62-.887-1.24-1.823-2.263-2.195-1.129-.422-2.381 0-3.515.372l-13.261 4.65c-5.444 1.903-6.888 4.575-7.645 10.105a54.644 54.644 0 00.465 17.514z",
    fill: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M119.88 187.185a1.94 1.94 0 001.959 1.891c4.332.849 8.787.849 13.119 0a1.407 1.407 0 001.049-.47 1.402 1.402 0 00.34-1.099l.905-8.89a70.943 70.943 0 005.127 9.262l14.259-9.987a3.211 3.211 0 001.314-1.401c.298-.874-.204-1.798-.694-2.579a580.553 580.553 0 00-11.159-17.173c-.62-.887-1.24-1.823-2.263-2.195-1.129-.422-2.381 0-3.515.372l-13.261 4.65c-5.444 1.903-6.888 4.575-7.645 10.105a54.644 54.644 0 00.465 17.514z",
    fill: "url(#prefix__paint9_linear_15788_47707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.439 108.084c.245.298.371.675.353 1.06a2.45 2.45 0 01-.372.676c-.427.756-.142 1.742-.452 2.554-.31.813-1.24 1.339-1.966 1.86a10.38 10.38 0 01-1.76 1.24 1.855 1.855 0 01-2.015-.173 2.514 2.514 0 01-.583-1.501 49.663 49.663 0 01-.539-6.987 2.35 2.35 0 01.186-1.116c.178-.282.423-.516.713-.682 1.24-.781 3.279-1.277 4.687-.62 1.258.589 1.134 2.567 1.748 3.689z",
    fill: "url(#prefix__paint10_linear_15788_47707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.408 98.816c1.302-.453 2.902-.33 3.856.663.515.533.812 1.283 1.439 1.674a3.103 3.103 0 001.99.273 4.944 4.944 0 012.027 0 1.4 1.4 0 011.048 1.531c-.137.545-.682.862-1.184 1.122a145.25 145.25 0 01-7.074 3.447 11.12 11.12 0 01-2.288.849 1.775 1.775 0 01-1.079 0 1.755 1.755 0 01-.62-.508 7.442 7.442 0 01-1.859-5.474c.136-1.786 2.163-3.026 3.744-3.578z",
    fill: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M136.408 98.816c1.302-.453 2.902-.33 3.856.663.515.533.812 1.283 1.439 1.674a3.103 3.103 0 001.99.273 4.944 4.944 0 012.027 0 1.4 1.4 0 011.048 1.531c-.137.545-.682.862-1.184 1.122a145.25 145.25 0 01-7.074 3.447 11.12 11.12 0 01-2.288.849 1.775 1.775 0 01-1.079 0 1.755 1.755 0 01-.62-.508 7.442 7.442 0 01-1.859-5.474c.136-1.786 2.163-3.026 3.744-3.578z",
    fill: "url(#prefix__paint11_linear_15788_47707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.504 250.65c8.382-5.381 14.588-13.546 22.461-19.646a56.28 56.28 0 0128.872-11.457c1.86-.18 3.813-.255 5.58.409 2.045.769 3.595 2.449 5.065 4.073l24.135 26.615a36.56 36.56 0 005.97 5.666c2.66 1.86 5.747 2.97 8.617 4.483 9.802 5.151 16.504 14.575 22.827 23.657a197.632 197.632 0 00-51.413 11.073c-7.086 2.554-14.048 5.517-21.345 7.396-11.06 2.839-22.604 3.1-34.024 3.1-13.112-.037-26.242-.447-39.293-1.73-7.191-.713-14.482-1.792-21.258-4.383-4.532-1.736-16.553-7.117-14.88-13.187 1.018-3.719 9.362-10.582 12.338-13.781 5.133-5.518 12.17-8.81 19.138-11.389 9.138-3.416 18.884-5.555 27.21-10.899z",
    fill: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M230.024 284.451a197.409 197.409 0 00-51.413 11.072c-7.086 2.548-14.049 5.518-21.346 7.396-11.06 2.84-22.603 3.1-34.023 3.1-13.112 0-26.243-.446-39.3-1.73l-1.24-.136c-6.781-.707-13.638-1.804-20.005-4.247-4.526-1.742-16.547-7.117-14.88-13.193 1.017-3.719 9.368-10.576 12.344-13.775 5.127-5.518 12.164-8.81 19.132-11.389 9.163-3.391 18.915-5.53 27.241-10.868s14.588-13.558 22.468-19.652a56.254 56.254 0 0128.865-11.457c1.86-.174 3.813-.255 5.579.403a8.719 8.719 0 012.344 1.376 24.845 24.845 0 012.722 2.697l24.128 26.621a36.938 36.938 0 005.977 5.666c2.659 1.86 5.747 2.97 8.617 4.483 9.758 5.12 16.46 14.55 22.79 23.633z",
    fill: "url(#prefix__paint12_linear_15788_47707)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M165.754 221.357a69.871 69.871 0 01-10.242 10.204c-6.36 5.127-14.073 9.765-16.497 17.57-1.692 5.443-.62 12.015-4.445 16.255-4.34 4.805-13.193 4.34-16.119 10.112-.694 1.382-.924 2.945-1.395 4.414-2.604 8.097-11.624 11.829-19.287 15.499a110.68 110.68 0 00-15.09 8.748c-6.782-.707-13.639-1.804-20.006-4.247-4.525-1.742-16.546-7.117-14.879-13.193 1.017-3.72 9.368-10.576 12.344-13.775 5.127-5.518 12.163-8.81 19.132-11.389 9.163-3.391 18.915-5.53 27.241-10.868s14.587-13.558 22.467-19.653a56.265 56.265 0 0128.865-11.456c1.86-.174 3.813-.255 5.58.402.844.335 1.63.8 2.331 1.377z",
    fill: "url(#prefix__paint13_linear_15788_47707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.87 120.353c1.413 2.703 1.779 6.119.279 8.772a4.693 4.693 0 01-2.449 2.207 2.77 2.77 0 01-3.05-.805 56.78 56.78 0 00-1.141 17.098c.173 2.04.434 4.216-.527 6.02a7.759 7.759 0 01-3.187 2.92c-6.41 3.596-14.364 2.932-21.457 1.017a1.911 1.911 0 01-1.367-.73 1.899 1.899 0 01-.349-.711 1.902 1.902 0 01-.032-.791c-.142-3.286-.142-6.578-.149-9.87v-13.118c0-4.111.062-8.463 2.214-11.959a8.983 8.983 0 013.577-3.385 15.006 15.006 0 014.389-1.154c7.495-1.14 19.25-5.48 23.249 4.489z",
    fill: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M149.87 120.353c1.413 2.703 1.779 6.119.279 8.772a4.693 4.693 0 01-2.449 2.207 2.77 2.77 0 01-3.05-.805 56.78 56.78 0 00-1.141 17.098c.173 2.04.434 4.216-.527 6.02a7.759 7.759 0 01-3.187 2.92c-6.41 3.596-14.364 2.932-21.457 1.017a1.911 1.911 0 01-1.367-.73 1.899 1.899 0 01-.349-.711 1.902 1.902 0 01-.032-.791c-.142-3.286-.142-6.578-.149-9.87v-13.118c0-4.111.062-8.463 2.214-11.959a8.983 8.983 0 013.577-3.385 15.006 15.006 0 014.389-1.154c7.495-1.14 19.25-5.48 23.249 4.489z",
    fill: "url(#prefix__paint14_linear_15788_47707)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M138.834 119.888a25.01 25.01 0 000 3.652c0 3.322-1.24 6.497-2.25 9.677-1.011 3.18-1.631 6.689-.372 9.771.195.39.328.808.397 1.24a6.216 6.216 0 01-.099 1.054 10.28 10.28 0 00.303 2.944c.577 3.23.447 6.535.323 9.808-.403.05-.577-.49-.62-.893l-.465-7.117c-1.699 1.569-1.011 4.34-1.482 6.597a1.8 1.8 0 01-.831 1.345 1.446 1.446 0 01-1.748-.713 4.203 4.203 0 01-.391-2.015l-.303-12.213a82.396 82.396 0 01.31-12.399c.303-2.424.818-4.811 1.24-7.223a18.72 18.72 0 011.196-4.854 8.478 8.478 0 016.776-4.805c.54-.049 2.22-.105 2.325.663.068.503-1.525 1.073-1.891 1.358a6.4 6.4 0 00-2.418 4.123z",
    fill: "url(#prefix__paint15_linear_15788_47707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.836 142.002c-1.519 1.097-3.41 1.941-5.226 1.482-.199.359.105.824.477.998.372.174.812.192 1.196.335a2.58 2.58 0 011.488 2.064c.088.888.074 1.782-.043 2.666-.192 3.1.583 6.156 1.351 9.157.273 1.054.98 2.387 2.034 2.095.886-.248 1.023-1.432.967-2.349a69.461 69.461 0 00-1.147-8.835c-.31-1.562-.657-3.255.031-4.687a9.673 9.673 0 011.19-1.692c1.575-2.034 3.1-5.27 2.691-7.874-.936.719-1.184 2.325-1.829 3.323a12.454 12.454 0 01-3.18 3.317z",
    fill: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M138.836 142.002c-1.519 1.097-3.41 1.941-5.226 1.482-.199.359.105.824.477.998.372.174.812.192 1.196.335a2.58 2.58 0 011.488 2.064c.088.888.074 1.782-.043 2.666-.192 3.1.583 6.156 1.351 9.157.273 1.054.98 2.387 2.034 2.095.886-.248 1.023-1.432.967-2.349a69.461 69.461 0 00-1.147-8.835c-.31-1.562-.657-3.255.031-4.687a9.673 9.673 0 011.19-1.692c1.575-2.034 3.1-5.27 2.691-7.874-.936.719-1.184 2.325-1.829 3.323a12.454 12.454 0 01-3.18 3.317z",
    fill: "url(#prefix__paint16_linear_15788_47707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.613 114.68c.713-.043 1.419.106 2.132.093.223 0 .509-.068.54-.291a.47.47 0 00-.186-.372 5.213 5.213 0 00-3.007-1.376 15.651 15.651 0 00-3.366 0 1.859 1.859 0 00-1.104.316c-.973.8-.44 3.1.843 3.311.744.117 1.24-.472 1.81-.844a4.835 4.835 0 012.338-.837z",
    fill: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M141.613 114.68c.713-.043 1.419.106 2.132.093.223 0 .509-.068.54-.291a.47.47 0 00-.186-.372 5.213 5.213 0 00-3.007-1.376 15.651 15.651 0 00-3.366 0 1.859 1.859 0 00-1.104.316c-.973.8-.44 3.1.843 3.311.744.117 1.24-.472 1.81-.844a4.835 4.835 0 012.338-.837z",
    fill: "url(#prefix__paint17_linear_15788_47707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.278 154.29a67.96 67.96 0 014.073-8.487 9.724 9.724 0 001.116-2.437c.372-1.537-.099-3.149-.62-4.65a76.502 76.502 0 00-3.652-8.865c-.359-.732-1.023-2.988-1.897-3.044-1.047-.068-2.808 1.364-3.577 1.978a1.194 1.194 0 00-.635.763 1.178 1.178 0 00.17.979c1.166 2.523 2.61 4.922 3.528 7.539.294.833.502 1.696.62 2.572.62 4.383-1.005 8.804-2.92 12.809a26.81 26.81 0 00-2.102 4.922c-.428 1.736-.322 3.72.775 5.127l2.002-1.903 2.449 2.058c.552-.62.502-1.562.471-2.393-.167-4.916 1.557-9.671 2.784-14.432.831-3.212 1.432-6.572 1.085-9.92-.372-3.565-2.238-6.633-3.794-9.789a1.318 1.318 0 00-.155-.254",
    fill: "url(#prefix__paint18_linear_15788_47707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.092 92.554a11.89 11.89 0 00-3.025-3.422c-2.704-1.86-6.293-1.544-9.554-1.153-5.053.62-10.936 1.779-13.143 6.367-.918 1.91-1.005 4.091-1.029 6.199-.205 13.875 1.24 27.799-.031 41.618-.416 4.396-1.11 8.853-.36 13.212.75 4.358 3.286 8.716 7.44 10.248 2.548.936 5.368.706 8.059.396 3.257-.38 6.495-.857 9.715-1.432 1.302-.229 2.69-.527 3.602-1.488.911-.961 1.141-2.411 1.24-3.75.576-6.504-1.197-12.567-1.153-18.971.031-4.656 2.579-8.822 3.719-13.267 2.914-11.612 1.073-24.464-5.48-34.557z",
    fill: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M136.563 127.123c-1.116 4.445-3.664 8.618-3.72 13.267-.037 6.411 1.73 12.468 1.154 18.971-.118 1.339-.335 2.778-1.24 3.751-.906.973-2.3 1.24-3.602 1.494a167.25 167.25 0 01-9.715 1.426c-2.592.298-5.301.527-7.768-.298-.099 0-.199-.062-.304-.105-4.141-1.519-6.677-5.883-7.44-10.248-.762-4.365-.055-8.81.354-13.211 1.308-13.819-.174-27.737.031-41.612 0-2.114.118-4.303 1.029-6.2 1.86-3.912 6.429-5.331 10.855-6.05a62.964 62.964 0 012.282-.317c3.261-.396 6.819-.713 9.553 1.147a11.653 11.653 0 013.026 3.429c6.584 10.074 8.425 22.926 5.505 34.556z",
    fill: "url(#prefix__paint19_linear_15788_47707)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M126.342 127.123c-1.123 4.445-3.664 8.617-3.72 13.267-.05 6.41 1.73 12.467 1.153 18.971-.118 1.339-.335 2.777-1.24 3.751-.905.973-2.3 1.239-3.596 1.494-2.409.413-4.829.789-7.259 1.128-.1 0-.199-.062-.304-.105-4.142-1.519-6.677-5.884-7.44-10.248-.762-4.365-.056-8.81.354-13.212 1.308-13.819-.174-27.737.031-41.611 0-2.115.117-4.303 1.029-6.2 1.86-3.912 6.429-5.332 10.855-6.05a7.927 7.927 0 011.612.83 11.701 11.701 0 013.019 3.428c6.584 10.075 8.426 22.926 5.506 34.557z",
    fill: "url(#prefix__paint20_linear_15788_47707)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M116.077 128.177a.838.838 0 00-.403.328.862.862 0 00.037.62c.797 2.877.78 5.918-.05 8.785a48.078 48.078 0 01-3.267 8.271l6.541-1.054c1.481-.236 3.056-.472 4.457.074 1.501.577 2.579 1.953 4.073 2.548a21.621 21.621 0 00-12.188 1.073 3.928 3.928 0 00-2.188 1.611c-.214.466-.328.97-.335 1.482-.236 3.832 1.333 7.514 2.87 11.035a4.171 4.171 0 012.685 1.061 65.76 65.76 0 01-5.809 1.965c-.788.229-1.798.372-2.282-.292a2.03 2.03 0 01-.291-.898 91.166 91.166 0 01-1.507-12.865c-.186-8.927 2.232-17.724 5.425-26.038.098-.354.298-.671.576-.911.236-.139.498-.226.769-.255l7.998-1.376c1.016-.173 5.015-1.277 4.556.62-.396 1.674-3.806 1.476-4.959 1.711a27.898 27.898 0 00-6.708 2.505z",
    fill: "url(#prefix__paint21_linear_15788_47707)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M128.859 95.505c-1.742.986-3.72 2.48-3.435 4.482.107.553.293 1.087.552 1.587a20.327 20.327 0 011.699 7.366 27.843 27.843 0 00-3.354-5.58 16.43 16.43 0 00-1.724 6.509c-.056 1.061 0 2.177-.521 3.1-.781 1.451-2.579 1.978-4.203 2.257-1.624.279-3.41.527-4.538 1.73-.031-1.085-1.135-1.86-2.207-2.046-1.073-.186-2.17.062-3.261.049-1.091-.012-2.306-.359-2.821-1.32-.515-.961-.13-2.189.335-3.205a25.421 25.421 0 014.34-6.498c2.083-2.281 4.569-4.172 6.571-6.515 1.122-1.309 2.089-2.76 3.305-3.98a7.498 7.498 0 014.463-2.406c1.24-.111 4.6-.186 5.617.533 1.562 1.122.477 3.18-.818 3.937z",
    fill: "url(#prefix__paint22_linear_15788_47707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.337 125.821c.229 4.656.985 9.442-.379 13.906-.663 2.169-1.804 4.172-2.374 6.367-1.159 4.47.18 9.163 1.395 13.639.552 1.996.744 4.736-1.166 5.536a2.91 2.91 0 01-3.137-.899 7.443 7.443 0 01-1.494-3.1 39.567 39.567 0 01-.694-18.791c.899-4.34 2.542-8.568 3.143-12.982.651-4.773.056-9.622-.576-14.401-.199-1.482-.087-3.466 1.357-3.85a3.217 3.217 0 011.494.099c3.72.874 3.051 1.748 2.685 5.269a86.512 86.512 0 00-.254 9.207z",
    fill: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M113.337 125.821c.229 4.656.985 9.442-.379 13.906-.663 2.169-1.804 4.172-2.374 6.367-1.159 4.47.18 9.163 1.395 13.639.552 1.996.744 4.736-1.166 5.536a2.91 2.91 0 01-3.137-.899 7.443 7.443 0 01-1.494-3.1 39.567 39.567 0 01-.694-18.791c.899-4.34 2.542-8.568 3.143-12.982.651-4.773.056-9.622-.576-14.401-.199-1.482-.087-3.466 1.357-3.85a3.217 3.217 0 011.494.099c3.72.874 3.051 1.748 2.685 5.269a86.512 86.512 0 00-.254 9.207z",
    fill: "url(#prefix__paint23_linear_15788_47707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.766 211.692c-.304.028-.59.157-.812.366a1.43 1.43 0 00-.168 1.054l.726 6.819c.086.868.266 1.86 1.029 2.288.312.151.651.24.998.26 4.588.558 9.192.912 13.813 1.06.539 0 1.178 0 1.457-.483.137-.275.168-.591.086-.887a4.343 4.343 0 00-2.077-2.616c-.967-.62-2.058-1.004-3.056-1.556a10.97 10.97 0 01-4.191-4.104c-.719-1.24-1.382-2.79-2.932-2.964-1.346-.161-3.503.465-4.873.763zM128.226 224.562c-.632.003-1.249.2-1.766.564a2.69 2.69 0 00-.732 1.668 8.67 8.67 0 00.335 3.862c.081.305.232.588.44.825a2.157 2.157 0 001.711.39 21.47 21.47 0 009.492-3.013c1.023-.62 2.076-1.463 2.219-2.647a1.105 1.105 0 00-.155-.781c-.521-.713-4.154-1.023-5.164-1.24-2.052-.397-4.321.149-6.38.372z",
    fill: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M155.766 211.692c-.304.028-.59.157-.812.366a1.43 1.43 0 00-.168 1.054l.726 6.819c.086.868.266 1.86 1.029 2.288.312.151.651.24.998.26 4.588.558 9.192.912 13.813 1.06.539 0 1.178 0 1.457-.483.137-.275.168-.591.086-.887a4.343 4.343 0 00-2.077-2.616c-.967-.62-2.058-1.004-3.056-1.556a10.97 10.97 0 01-4.191-4.104c-.719-1.24-1.382-2.79-2.932-2.964-1.346-.161-3.503.465-4.873.763z",
    fill: "url(#prefix__paint24_linear_15788_47707)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M128.226 224.562c-.632.003-1.249.2-1.766.564a2.69 2.69 0 00-.732 1.668 8.67 8.67 0 00.335 3.862c.081.305.232.588.44.825a2.157 2.157 0 001.711.39 21.47 21.47 0 009.492-3.013c1.023-.62 2.076-1.463 2.219-2.647a1.105 1.105 0 00-.155-.781c-.521-.713-4.154-1.023-5.164-1.24-2.052-.397-4.321.149-6.38.372z",
    fill: "url(#prefix__paint25_linear_15788_47707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.764 149.646c-.062.974-.142 1.947-.217 2.92a9.248 9.248 0 00-4.959-2.752 2.996 2.996 0 00-1.637.037 3.611 3.611 0 00-1.569 1.618 1179.013 1179.013 0 00-7.811 12.827c-1.116-1.414-1.37-3.292-1.668-5.065-.297-1.773-.781-3.658-2.145-4.83-1.364-1.171-3.887-1.085-4.606.565-.093-1.786-2.641-2.424-4.191-1.538-1.55.887-2.381 2.604-3.441 4.042a13.644 13.644 0 01-12.139 5.394c-1.24-.124-2.48-.409-3.664 0-1.432.514-2.318 1.965-3.682 2.647-2.821 1.407-6.051-1.066-7.787-3.682a56.856 56.856 0 00-5.232-6.808l.093-.055c1.494 1.239 2.827 2.87 4.513 3.868 4.34 2.567 10.025.539 14.141-2.399 4.117-2.939 7.744-6.82 12.561-8.401 4.817-1.58 11.394.583 12.039 5.58 5.58-.713 6.435-10.037 11.972-11.06 3.961-.725 6.968 3.323 9.163 6.702l.266.39z",
    fill: "url(#prefix__paint26_linear_15788_47707)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M245.381 168.741c-7.936-4.111-15.413-10.081-24.334-10.67-3.577-.235-7.662.279-10.285-2.176-1.277-1.202-1.947-2.914-3.1-4.234-1.153-1.321-3.261-2.182-4.625-1.085-.762.62-1.035 1.643-1.239 2.598l-2.555 10.657c-.465 1.922-.948 3.893-2.083 5.511-1.351 1.922-3.472 3.1-5.462 4.396a61.493 61.493 0 00-18.846 18.89 448.723 448.723 0 0069.999-5.797c4.173-.676 22.747-2.294 23.441-7.29.725-5.301-17.638-9.108-20.911-10.8z",
    fill: "url(#prefix__paint27_linear_15788_47707)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M312.219 199.175a108.974 108.974 0 01-11.115 37.997c-3.249 6.442-7.266 13.063-6.758 20.26 5.58.763 11.004-2.789 14.129-7.439s4.389-10.298 5.58-15.784l5.344 12.337c.502 1.159 1.054 2.381 2.101 3.1 1.817 1.24 4.445.316 5.822-1.389 1.376-1.705 1.798-3.968 2.151-6.131a233.619 233.619 0 003.038-42.003 135.273 135.273 0 0118.14 22.362c1.897 2.927 3.72 5.983 4.569 9.368 1.004 3.949.657 8.103.812 12.182a49.658 49.658 0 009.188 26.838c2.641 3.689 5.58 9.455 1.761 11.959a7.767 7.767 0 01-3.1.961c-16.683 2.629-87.415 12.511-84.873-12.535 1.166-11.308 11.587-25.865 15.028-37.396 3.769-12.629 7.099-26.336 18.183-34.687z",
    fill: "url(#prefix__paint28_linear_15788_47707)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M174.632 261.977l5.989 6.348a24.09 24.09 0 00-1.185 10.279c.01.713.249 1.404.682 1.971.376.351.822.618 1.309.782 3.577 1.481 8.326 2.703 10.799-.273 1.116-1.346 1.687-3.484 3.41-3.782a3.956 3.956 0 012.052.366 61.412 61.412 0 0118.146 10.675 93.729 93.729 0 00-20.899 2.332c-4.054.917-8.059 2.107-12.033 3.298-5.815 1.736-27.811 12.399-21.699-.62 3.013-6.38 6.262-6.857 7.285-14.458.837-6.082 2.684-11.804 6.144-16.918z",
    fill: "url(#prefix__paint29_linear_15788_47707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.431 91.89c-2.48 2.12-4.922 2.58-6.59 5.797a18.985 18.985 0 00-1.817 9.3c.038 1.531.112 3.304-1.047 4.302a4.569 4.569 0 01-1.941.831 32.445 32.445 0 01-8.958.831 12.667 12.667 0 01-4.768-.998 6.211 6.211 0 01-2.046-1.457c-1.68-1.86-1.921-4.569-1.952-7.068-.038-3.496.248-7.21 2.269-10.068 1.419-2.015 3.583-3.404 5.833-4.427a27.347 27.347 0 0117.359-1.766c2.294.539 6.318 2.424 3.658 4.724z",
    fill: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M127.469 91.246c-2.442 2.108-4.922 2.567-6.584 5.797a19.047 19.047 0 00-1.86 9.299c.05 1.531.112 3.298-1.047 4.303a4.551 4.551 0 01-1.935.824 32.43 32.43 0 01-8.983.837 16.681 16.681 0 01-2.808-.347 6.2 6.2 0 01-2.046-1.457c-1.68-1.86-1.922-4.569-1.953-7.068-.037-3.496.248-7.21 2.269-10.068 1.42-2.014 3.583-3.403 5.834-4.426a27.347 27.347 0 0117.359-1.767c2.008.893 3.732 2.356 1.754 4.073z",
    fill: "url(#prefix__paint30_linear_15788_47707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.955 121.215a29.534 29.534 0 00-3.844-.118c-2.38.167-4.65 1.041-6.875 1.903a6.996 6.996 0 00-2.269 1.24 1.422 1.422 0 00-.533.973c0 .943 1.314 1.197 2.244 1.042 3.664-.62 7.353-2.685 10.886-1.531 1.587.52 2.933 1.655 4.538 2.114 1.015.245 2.058.349 3.1.31a4.968 4.968 0 002.133-.304 3.425 3.425 0 001.779-2.554c.955-5.227-7.879-2.865-11.159-3.075zM124.195 142.101a29.366 29.366 0 00-3.844-.111c-2.381.161-4.65 1.035-6.869 1.897a7.122 7.122 0 00-2.275 1.24 1.39 1.39 0 00-.527.973c0 .942 1.308 1.196 2.238 1.041 3.67-.62 7.359-2.678 10.886-1.525 1.594.515 2.933 1.649 4.538 2.114 1.015.24 2.058.342 3.1.304a5.089 5.089 0 002.139-.297 3.45 3.45 0 001.773-2.561c.961-5.22-7.88-2.858-11.159-3.075zM104.688 124.674a4.89 4.89 0 00-2.027.416 1.923 1.923 0 00-1.11 1.636c.041.459.192.901.44 1.29a.985.985 0 00.236.335 1.102 1.102 0 00.936.055 9.864 9.864 0 013.812-.13c.246.068.505.068.751 0 .843-.335 1.481-2.418.874-3.1-.707-.837-3.013-.533-3.912-.502zM100.556 143.744a2.485 2.485 0 00-.403 1.668v1.513l4.39-.056a.618.618 0 00.421-.106.622.622 0 00.168-.421c.136-1.104.558-2.666-.564-3.311-.819-.471-3.392.013-4.012.713z",
    fill: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M126.955 121.215a29.534 29.534 0 00-3.844-.118c-2.38.167-4.65 1.041-6.875 1.903a6.996 6.996 0 00-2.269 1.24 1.422 1.422 0 00-.533.973c0 .943 1.314 1.197 2.244 1.042 3.664-.62 7.353-2.685 10.886-1.531 1.587.52 2.933 1.655 4.538 2.114 1.015.245 2.058.349 3.1.31a4.968 4.968 0 002.133-.304 3.425 3.425 0 001.779-2.554c.955-5.227-7.879-2.865-11.159-3.075z",
    fill: "url(#prefix__paint31_linear_15788_47707)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M124.195 142.101a29.366 29.366 0 00-3.844-.111c-2.381.161-4.65 1.035-6.869 1.897a7.122 7.122 0 00-2.275 1.24 1.39 1.39 0 00-.527.973c0 .942 1.308 1.196 2.238 1.041 3.67-.62 7.359-2.678 10.886-1.525 1.594.515 2.933 1.649 4.538 2.114 1.015.24 2.058.342 3.1.304a5.089 5.089 0 002.139-.297 3.45 3.45 0 001.773-2.561c.961-5.22-7.88-2.858-11.159-3.075z",
    fill: "url(#prefix__paint32_linear_15788_47707)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M104.688 124.674a4.89 4.89 0 00-2.027.416 1.923 1.923 0 00-1.11 1.636c.041.459.192.901.44 1.29a.985.985 0 00.236.335 1.102 1.102 0 00.936.055 9.864 9.864 0 013.812-.13c.246.068.505.068.751 0 .843-.335 1.481-2.418.874-3.1-.707-.837-3.013-.533-3.912-.502z",
    fill: "url(#prefix__paint33_linear_15788_47707)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M100.556 143.744a2.485 2.485 0 00-.403 1.668v1.513l4.39-.056a.618.618 0 00.421-.106.622.622 0 00.168-.421c.136-1.104.558-2.666-.564-3.311-.819-.471-3.392.013-4.012.713z",
    fill: "url(#prefix__paint34_linear_15788_47707)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M130.68 172.101a1.38 1.38 0 00-.899-.52c-.62 0-.905.775-.973 1.394-.236 2.121.056 4.272-.136 6.398-.248 2.728-1.284 5.345-1.414 8.06-.045.389.006.782.149 1.147.434.948 1.711 1.079 2.752 1.01a30.359 30.359 0 005.27-.799c.333-.048.645-.19.899-.41.258-.335.393-.748.384-1.171.217-2.356 1.482-6.702.366-8.791-1.296-2.406-4.668-4.179-6.398-6.318z",
    fill: "url(#prefix__paint35_linear_15788_47707)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint0_linear_15788_47707",
    x1: 192.945,
    y1: 222.913,
    x2: 203.392,
    y2: 10.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint1_linear_15788_47707",
    x1: 234.768,
    y1: 235.021,
    x2: 263.485,
    y2: 95.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint2_linear_15788_47707",
    x1: 114.453,
    y1: 222.678,
    x2: 119.673,
    y2: -36.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#fff",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#fff",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint3_linear_15788_47707",
    x1: 162.336,
    y1: 161.339,
    x2: 168.213,
    y2: 385.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint4_linear_15788_47707",
    x1: 80.384,
    y1: 312.442,
    x2: 143.05,
    y2: 133.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint5_linear_15788_47707",
    x1: 207.488,
    y1: 220.421,
    x2: 480.773,
    y2: 294.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint6_linear_15788_47707",
    x1: 186.675,
    y1: 186.819,
    x2: 343.711,
    y2: 296.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint7_linear_15788_47707",
    x1: 122.737,
    y1: 207.262,
    x2: 133.403,
    y2: 207.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A4621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#BE6F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5A28F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint8_linear_15788_47707",
    x1: 149.807,
    y1: 195.616,
    x2: 161.792,
    y2: 195.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A4621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#BE6F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5A28F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint9_linear_15788_47707",
    x1: 142.298,
    y1: 164.525,
    x2: 292,
    y2: -141.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint10_linear_15788_47707",
    x1: 136.094,
    y1: 109.895,
    x2: 143.764,
    y2: 109.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A4621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#BE6F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5A28F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint11_linear_15788_47707",
    x1: 130.996,
    y1: 103.006,
    x2: 165.484,
    y2: 106.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint12_linear_15788_47707",
    x1: 101.376,
    y1: 246.521,
    x2: 268.48,
    y2: 422.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint13_linear_15788_47707",
    x1: 80.001,
    y1: 243.892,
    x2: 248.289,
    y2: 326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint14_linear_15788_47707",
    x1: 121.544,
    y1: 135.468,
    x2: 179.857,
    y2: 140.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint15_linear_15788_47707",
    x1: 118.791,
    y1: 131.413,
    x2: 165.648,
    y2: 142.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint16_linear_15788_47707",
    x1: 134.223,
    y1: 142.628,
    x2: 172.301,
    y2: 170.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint17_linear_15788_47707",
    x1: 136.957,
    y1: 114.6,
    x2: 149.833,
    y2: 113.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint18_linear_15788_47707",
    x1: 145.143,
    y1: 145.239,
    x2: 156.556,
    y2: 145.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A4621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#BE6F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5A28F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint19_linear_15788_47707",
    x1: 66.557,
    y1: 114.606,
    x2: 261.95,
    y2: 160.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint20_linear_15788_47707",
    x1: 73.67,
    y1: 117.501,
    x2: 224.023,
    y2: 153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint21_linear_15788_47707",
    x1: 108.408,
    y1: 144.488,
    x2: 127.782,
    y2: 144.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint22_linear_15788_47707",
    x1: 105.226,
    y1: 93.534,
    x2: 156.72,
    y2: 132.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint23_linear_15788_47707",
    x1: 91.96,
    y1: 137.687,
    x2: 182.475,
    y2: 140.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint24_linear_15788_47707",
    x1: 148.5,
    y1: 218.598,
    x2: 280.217,
    y2: 208.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint25_linear_15788_47707",
    x1: 128.797,
    y1: 229.999,
    x2: 217.866,
    y2: 151.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint26_linear_15788_47707",
    x1: 288.109,
    y1: 174.42,
    x2: 286.367,
    y2: 120.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#fff",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#fff",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint27_linear_15788_47707",
    x1: 184.315,
    y1: 145.474,
    x2: 249.59,
    y2: 219.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint28_linear_15788_47707",
    x1: 370.279,
    y1: 371.282,
    x2: 242.344,
    y2: 86.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint29_linear_15788_47707",
    x1: 174.123,
    y1: 226.484,
    x2: 195.667,
    y2: 329.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint30_linear_15788_47707",
    x1: 100.11,
    y1: 90.961,
    x2: 149.031,
    y2: 119.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint31_linear_15788_47707",
    x1: 121.195,
    y1: 110.644,
    x2: 149.193,
    y2: 192.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint32_linear_15788_47707",
    x1: 112.354,
    y1: 113.651,
    x2: 140.345,
    y2: 195.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint33_linear_15788_47707",
    x1: 102.072,
    y1: 117.154,
    x2: 130.069,
    y2: 199.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint34_linear_15788_47707",
    x1: 94.016,
    y1: 119.894,
    x2: 122.013,
    y2: 202.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint35_linear_15788_47707",
    x1: 146.285,
    y1: 180.105,
    x2: 69.118,
    y2: 182.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiking0D626B06);
export default __webpack_public_path__ + "static/media/hiking.0d626b06.c5e166e2bfd9773d2257ccb1742ddeb2.svg";
export { ForwardRef as ReactComponent };